import * as types from './types';

export const showToast = payload => ({ type: types.SHOW, payload });

export const hideToast = () => ({ type: types.HIDE });
